import { render, staticRenderFns } from "./CardknoxDeviceIpPort.vue?vue&type=template&id=268c2a56&"
import script from "./CardknoxDeviceIpPort.vue?vue&type=script&lang=ts&"
export * from "./CardknoxDeviceIpPort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports